import { LOGIN_ENDPOINT } from "../Utils/constant";
import clientAxios from "./axios";

export const loginUser = async (...data) => {
  return await clientAxios.post(`${LOGIN_ENDPOINT}`, ...data);
};
